import Vue from 'vue'
import Router from 'vue-router'

const Login = () => import('@/components/login/login')
const ApprovalLogin = () => import('@/components/approval-login')
const Open = () => import('@/components/open/open')
const Register = () => import('@/components/register/register')
const ForgetPassword = () => import('@/components/forget-password/forget-password')
const ApprovalForgetPwd = () => import('@/components/approval-forget-pwd')
const Approval = () => import('@/components/approval')
const Home = () => import('@/components/home/home')
const Log = () => import('@/components/log/log')
const House = () => import('@/components/house/house')
const AddHouse = () => import('@/components/add-house/add-house')
const BatchOperate = () => import('@/components/batch-operate/batch-operate')
const Rooms = () => import('@/components/rooms/rooms')
const RoomInfo = () => import('@/components/room-info/room-info')
const AddTenant = () => import('@/components/add-tenant/add-tenant')
const NetManage = () => import('@/components/net-manage/net-manage')
const PermissionManage = () => import('@/components/permission-manage/permission-manage')
const Person = () => import('@/components/person/person')
const Facility = () => import('@/components/facility/facility')
const FacilityInfo = () => import('@/components/facilityInfo/facilityInfo')
const AddNbtenant = () => import('@/components/add-nbtenant/add-nbtenant')
const PermissionManageNb = () => import('@/components/permission-managenb/permission-managenb')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/approvalLogin',
      name: 'ApprovalLogin',
      component: ApprovalLogin
    },
    {
      path: '/open',
      name: 'Open',
      component: Open
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/forgetPassword',
      name: 'ForgetPassword',
      component: ForgetPassword
    },
    {
      path: '/approvalForgetPwd',
      name: 'ApprovalForgetPwd',
      component: ApprovalForgetPwd
    },
    {
      path: '/approval',
      name: 'Approval',
      component: Approval
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/house',
      name: 'House',
      component: House
    },
    {
      path: '/house/add-house',
      name: 'House/AddHouse',
      component: AddHouse
    },
    {
      path: '/house/batch-operate/:id',
      name: 'House/BatchOperate',
      component: BatchOperate
    },
    {
      path: '/rooms',
      name: 'Rooms',
      component: Rooms
    },
    {
      path: '/roomInfo/:id/:roomId',
      name: 'Rooms/RoomInfo',
      component: RoomInfo
    },
    {
      path: '/addTenant',
      name: 'Rooms/AddTenant',
      component: AddTenant
    },
    {
      path: '/permissionManage',
      name: 'Rooms/PermissionManage',
      component: PermissionManage
    },
    {
      path: '/netManage',
      name: 'Rooms/NetManage',
      component: NetManage
    },
    {
      path: '/facility',
      name: 'Facility',
      component: Facility
    },
    {
      path: '/facilityInfo/:id/:roomId',
      name: 'Facility/FacilityInfo',
      component: FacilityInfo
    },
    {
      path: '/addNbtenant',
      name: 'Facility/addNbtenant',
      component: AddNbtenant
    },
    {
      path: '/permissionManagenb',
      name: 'Facility/PermissionManagenb',
      component: PermissionManageNb
    },
    {
      path: '/log',
      name: 'Log',
      component: Log
    },
    {
      path: '/person',
      name: 'Person',
      component: Person
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js